"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _Sort = _interopRequireDefault(require("@material-ui/icons/Sort"));
var _Timeline = _interopRequireDefault(require("@material-ui/lab/Timeline"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _DaySeparator = _interopRequireDefault(require("./components/DaySeparator"));
var _TimelineItem = _interopRequireDefault(require("./components/TimelineItem"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    controlsContainerRoot: {
      marginTop: '13px',
      // Replacing the margin dropped from the timeline when the controls are rendered
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(2)
    },
    sortIcon: {
      color: theme.palette.opacity.black[60]
    },
    timelineWithControls: {
      marginBlockStart: 0,
      paddingTop: 0
    }
  };
});
var defaultProps = {
  align: 'left',
  dataMetrics: {
    controls: 'fuse_timeline_controls',
    root: 'fuse_timeline'
  }
};

/**
 * The Vertical Activity Timeline allows users to view a sequence of events in a vertical space such as a drawer or mobile experience.
 */
var _ref = /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
  label: true
}, "Sort By");
var Timeline = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var align = props.align,
    activities = props.activities,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    dataMetrics = props.dataMetrics,
    dayGroupTextFormatter = props.dayGroupTextFormatter,
    enableSorting = props.enableSorting,
    groupByDay = props.groupByDay,
    endConnector = props.endConnector,
    TimelineConnectorProps = props.TimelineConnectorProps,
    TimelineContentProps = props.TimelineContentProps,
    TimelineDotProps = props.TimelineDotProps,
    TimelineItemProps = props.TimelineItemProps,
    TimelineOppositeContentProps = props.TimelineOppositeContentProps,
    TimelineSeparatorProps = props.TimelineSeparatorProps;
  var buttonRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)('olderFirst'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    sortOrder = _useState2[0],
    setSortOrder = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    menuAnchor = _useState4[0],
    setMenuAnchor = _useState4[1];
  var sortingMenuId = (0, _react.useMemo)(function () {
    return "sorting-menu-".concat(Date.now());
  }, []);
  var styles = useStyles();
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  function handleSortingClicked() {
    var nextSortOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'olderFirst';
    return function onSortingClicked() {
      setMenuAnchor(null);
      setSortOrder(nextSortOrder);
    };
  }
  var timelineItems = (0, _react.useMemo)(function () {
    var groupDates = [];
    return (sortOrder === 'newerFirst' ? (0, _toConsumableArray2["default"])(activities).reverse() : activities).reduce(function (acc, activity, idx) {
      var prepend = [];
      if (groupByDay && !groupDates.includes(activity.date)) {
        prepend.push( /*#__PURE__*/_react["default"].createElement(_DaySeparator["default"], {
          date: activity.date,
          key: activity.date,
          textFormatter: dayGroupTextFormatter,
          disableConnector: idx === 0,
          TimelineConnectorProps: TimelineConnectorProps,
          TimelineOppositeContentProps: TimelineOppositeContentProps,
          TimelineSeparatorProps: TimelineSeparatorProps
        }));
        groupDates.push(activity.date);
      }
      return [].concat((0, _toConsumableArray2["default"])(acc), prepend, [/*#__PURE__*/_react["default"].createElement(_TimelineItem["default"], {
        activity: activity
        // eslint-disable-next-line react/no-array-index-key
        ,
        key: idx,
        renderConnector: idx + 1 !== activities.length || idx + 1 === activities.length && endConnector,
        TimelineConnectorProps: TimelineConnectorProps,
        TimelineContentProps: TimelineContentProps,
        TimelineDotProps: TimelineDotProps,
        TimelineItemProps: TimelineItemProps,
        TimelineOppositeContentProps: TimelineOppositeContentProps,
        TimelineSeparatorProps: TimelineSeparatorProps
      })]);
    }, []);
  }, [activities, dayGroupTextFormatter, endConnector, groupByDay, sortOrder, TimelineConnectorProps, TimelineContentProps, TimelineDotProps, TimelineItemProps, TimelineOppositeContentProps, TimelineSeparatorProps]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, enableSorting && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    alignItems: "center",
    classes: {
      root: styles.controlsContainerRoot
    },
    container: true,
    "data-metrics": mergedDataMetrics.controls,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick() {
      return setMenuAnchor(buttonRef);
    },
    ref: buttonRef
  }, /*#__PURE__*/_react["default"].createElement(_Sort["default"], {
    className: styles.sortIcon
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    alignment: "right",
    anchorEl: menuAnchor && menuAnchor.current,
    id: sortingMenuId,
    onClose: function onClose() {
      return setMenuAnchor(null);
    },
    open: Boolean(menuAnchor)
  }, _ref, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: handleSortingClicked(),
    selected: sortOrder === 'olderFirst'
  }, "Older to Newer"), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: handleSortingClicked('newerFirst'),
    selected: sortOrder === 'newerFirst'
  }, "Newer to Older")))), /*#__PURE__*/_react["default"].createElement(_Timeline["default"], {
    align: align,
    classes: _objectSpread({}, classes, {
      root: (0, _classnames["default"])(classes.root, (0, _defineProperty2["default"])({}, styles.timelineWithControls, enableSorting))
    }),
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, timelineItems));
});
Timeline.defaultProps = defaultProps;
Timeline.displayName = 'Timeline';
Timeline.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The activities in the timeline.
   */
  activities: _propTypes["default"].arrayOf(_constants.TimelineActivityPropType).isRequired,
  /**
   * The position where timeline's content should appear.
   */
  align: _propTypes["default"].oneOf(['alternate', 'left', 'right']),
  /**
   * Override or extend the styles applied to the component. [CSS API](https://v4.mui.com/api/timeline/#css) for more details.
   */
  classes: _propTypes["default"].shape({
    alignAlternate: _propTypes["default"].string,
    alignLeft: _propTypes["default"].string,
    alignRight: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    controls: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  /**
   * Optional formatter allowing for the customization of date group text.
   */
  dayGroupTextFormatter: _propTypes["default"].func,
  /**
   * Allow the user to sort the timeline.
   * Note: The activities prop value must be a pre-sorted(oldest to newest) array.
   */
  enableSorting: _propTypes["default"].bool,
  /**
   * Show a connector at the end of the timeline.
   */
  endConnector: _propTypes["default"].bool,
  /**
   * Group dates using a badge component.
   */
  groupByDay: _propTypes["default"].bool,
  /**
   * Additional props to apply to the inner TimelineConnector Components.
   *
   * See [TimelineConnector API](https://material-ui.com/api/timeline-connector/) for more details.
   */
  TimelineConnectorProps: _constants.TimelineConnectorPropType,
  /**
   * Additional props to apply to the inner TimelineContent Components.
   *
   * See [TimelineContent API](https://material-ui.com/api/timeline-content/) for more details.
   */
  TimelineContentProps: _constants.TimelineContentPropType,
  /**
   * Additional props to apply to the inner TimelineDot Components.
   *
   * See [TimelineDot API](https://material-ui.com/api/timeline-dot/) for more details.
   */
  TimelineDotProps: _constants.TimelineDotPropType,
  /**
   * Additional props to apply to the inner TimelineItem Components.
   *
   * See [TimelineItem API](https://material-ui.com/api/timeline-item/) for more details.
   */
  TimelineItemProps: _constants.TimelineItemPropType,
  /**
   * Additional props to apply to the inner TimelineOppositeContent Components.
   *
   * See [TimelineOppositeContent API](https://material-ui.com/api/timeline-opposite-content/) for more details.
   */
  TimelineOppositeContentProps: _constants.TimelineOppositeContentPropType,
  /**
   * Additional props to apply to the inner TimelineSeparator Components.
   *
   * See [TimelineSeparator API](https://material-ui.com/api/timeline-separator/) for more details.
   */
  TimelineSeparatorProps: _constants.TimelineSeparatorPropType
} : {};
var _default = Timeline;
exports["default"] = _default;